export default __webpack_public_path__ + "static/media/logo-nixe.f005f3b5.png";